import tingle from "tingle.js";

(() => {
  const btns = document.getElementsByClassName("js-viddeo-open");

  let videos = [];
  if (btns.length > 0) {
    const btnsArray = Array.prototype.slice.call(btns, 0);
    btnsArray.forEach((btn) => {
      const id = btn.dataset.id;
      if (!id) return;
      videos[id] = new tingle.modal({
        closeMethods: ["overlay", "button", "escape"],
      });

      btn.addEventListener("click", (event) => {
        const videomodal = new tingle.modal({
          closeMethods: ["overlay", "button", "escape"],
          onClose: () => {
            videomodal.destroy();
          },
        });
        const tg = event.target.dataset.id;
        console.log("tg : ", tg);
        if (tg) {
          const iframe = `<div class="c-iframe-video"><iframe width="100%" height="480" src="https://www.youtube.com/embed/${tg}?autoplay=1" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>`;
          videomodal.setContent(iframe);
          videomodal.open();
        }
      });
    });
  }
})();
